import * as React from 'react';

const useUpdateRef = <T>(value: T) => {
    const ref = React.useRef(value);
    ref.current = value;
    return ref;
};

export default useUpdateRef;
